// Baselayer Results Explorer — Results tab. Side-by-side "Your Search" vs
// "Matched" with a match badge per row, driven by the KYB result's
// business_name_match / business_address_match / tin_matched flags.

import { SideBySideCompare, type CompareRow } from "../SideBySideCompare";
import { MatchBadge, boolToMatch } from "../MatchBadge";
import { asString, pick, type ParsedKyb } from "../parse";

export function ResultsTab({ kyb }: { kyb: ParsedKyb }) {
  const business = kyb.business;

  const searchedName =
    asString(pick(business, "search_name", "input_name")) ?? kyb.name ?? "—";
  const matchedName = kyb.name ?? "—";
  const searchedAddress =
    asString(pick(business, "search_address", "input_address")) ?? "—";
  const matchedAddress =
    asString(pick(business, "address", "matched_address", "registered_address")) ??
    "—";
  const searchedTin = asString(pick(business, "search_tin", "input_tin")) ?? "—";
  const matchedTin = asString(pick(business, "tin", "ein")) ?? "—";

  const rows: CompareRow[] = [
    {
      label: "Business name",
      searched: searchedName,
      matched: matchedName,
      badge: <MatchBadge kind={boolToMatch(kyb.nameMatch)} />,
    },
    {
      label: "Address",
      searched: searchedAddress,
      matched: matchedAddress,
      badge: <MatchBadge kind={boolToMatch(kyb.addressMatch)} />,
    },
    {
      label: "TIN",
      searched: searchedTin,
      matched: matchedTin,
      badge: <MatchBadge kind={boolToMatch(kyb.tinMatched)} />,
    },
  ];

  return <SideBySideCompare rows={rows} />;
}
